import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  output,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { PageResult } from '@core/model/pagination/page-result';
import { CommonModule } from '@angular/common';
import { NgOption } from '@ng-select/ng-select';
import { debounceTime, Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { AppUtilService, deepCopy } from '@shared/services/app-util.service';
import { AvatarComponent } from "../avatar/avatar.component";

@Component({
  selector: 'app-select-avatar',
  standalone: true,
  imports: [NgSelectComponent, NgOptionComponent, CommonModule, FormsModule, AvatarComponent],
  templateUrl: './select-avatar.component.html',
  styleUrl: './select-avatar.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectAvatarComponent),
      multi: true,
    },
  ],
})
export class SelectAvatarComponent implements ControlValueAccessor {
  @ViewChild('vs') vs: NgSelectComponent;
  @Output() search = new EventEmitter<string>();
  @Output() scrollEnd = new EventEmitter<any>();
  @Output() clear = new EventEmitter<boolean>();
  @Output() add = new EventEmitter<boolean>();
  @Output() selectionChanged = new EventEmitter<string>();
  @Input() appendToBody:boolean = true;
  @Input() clearSelectedValue:boolean = false;
  @Input() getAllDatainField:boolean = false;
  @Input() isCallPageRefresh:boolean = false;
  @Input() closeOnSelect:boolean = true;

  modelChanged = new Subject<string>();
  public selected;
  searchTerm;

  private _allowAll = false;
  public get allowAll() {
    return this._allowAll;
  }
  @Input() public set allowAll(v: boolean) {
    this._allowAll = v;
  }

  // tslint:disable-next-line: variable-name
  private _label: string | string[] = 'name';
  public get label() {
    return this._label;
  }
  @Input() public set label(v: string | string[]) {
    this._label = v;
  }

  private _isClearAble: boolean  = true;
  public get isClearAble() {
    return this._isClearAble;
  }
  @Input() public set isClearAble(v: boolean) {
    this._isClearAble = v;
  }
private _showRefresh: boolean  = true;
  public get showRefresh() {
    return this._showRefresh;
  }
  @Input() public set showRefresh(v: boolean) {
    this._showRefresh = v;
  }
  private _value: string | string[] = 'id';
  public get value() {
    return this._value;
  }
  @Input() public set value(v: string | string[]) {
    this._value = v;
  }
  private _placeHolder = '';
  public get placeHolder() {
    return this._placeHolder;
  }
  @Input() public set placeHolder(v: string) {
    this._placeHolder = v;
  }

  @Input() public disabled = false;
  @Input() public addNew = false;
  @Input() public multiple = false;
  @Input() initialSelectedValue: string | null = null;  // GUID or initial value
  @Input() public set clearAll(v: boolean) {
    if (v) {
      this.onClear();
    }
  }

  private _pageResult: PageResult<any>;
  public get pageResult(): PageResult<any> {
    return this._pageResult;
  }
  @Input() public set pageResult(v: PageResult<any>) {}

  loading = true;

  dataBuffer = [];
  bufferSize = 5;
  numberOfItemsFromEndBeforeFetchingMore = 2;

  onChanged: any = () => {};
  onTouched: any = () => {};

  constructor(public config: AppUtilService) {
    this.modelChanged.pipe(debounceTime(500)).subscribe(() => {
      this.onSearch();
    });
  }
  getLabel(item: any) {
    let value = deepCopy(item);
    if (Array.isArray(this.label)) {
      this.label.forEach((x) => {
        value = value[x];
      });
    } else {
      value = item[this.label];
    }
    return value;
  }
  getValue(item: any) {
    let value = deepCopy(item);
    if (Array.isArray(this.value)) {
      this.value.forEach((x) => {
        value = value[x];
      });
    } else {
      value = item[this.value];
    }

    return value;
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.pageResult?.currentValue) {
  //     if (!this._pageResult?.data?.length) {
  //       this._pageResult = changes.pageResult.currentValue;
  //       this.dataBuffer = this._pageResult.data?.length
  //         ? this._pageResult?.data?.slice(0, this.bufferSize)
  //         : [];
  //     } else {
  //       const newPageResult: PageResult<any> = changes.pageResult.currentValue;
  //       if (newPageResult) {
  //         this._pageResult.pageInfo = newPageResult?.pageInfo;
  //         this._pageResult.totalCount = newPageResult?.totalCount;
  //         newPageResult.data.forEach((element) => {
  //           if (!this._pageResult.data.find((x) => x.id === element.id)) {
  //             this._pageResult.data = [...this._pageResult.data];
  //             this._pageResult.data?.push(element);
  //           }
  //         });
  //       }
  //     }
  //     this.loadToBuffer();
  //     this.loading = false;
  //   }
  // }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['pageResult']?.currentValue) {
      if(this.isCallPageRefresh)
      {
        this._pageResult = new PageResult<any>();
      }
      // Handle pagination data updates as before
      if (!this._pageResult?.data?.length) {
        this._pageResult = changes['pageResult'].currentValue;
        this.dataBuffer = this._pageResult.data?.length
          ? this._pageResult?.data?.slice(0, this.bufferSize)
          : [];
      } else {
        const newPageResult: PageResult<any> = changes['pageResult'].currentValue;
        if (newPageResult) {
          this._pageResult.pageInfo = newPageResult?.pageInfo;
          this._pageResult.totalCount = newPageResult?.totalCount;
          newPageResult.data.forEach((element) => {
            if (!this._pageResult.data.find((x) => x.id === element.id)) {
              this._pageResult.data = [...this._pageResult.data];
              this._pageResult.data?.push(element);
            }
          });
        }
      }
      this.loadToBuffer();
      this.loading = false;
    }

    // Check for initial selected value and set it if available
    if ( this.initialSelectedValue) {
      const selectedItem = this._pageResult?.data?.find(
        (item) => item.id === this.initialSelectedValue
      );
      if (selectedItem) {
        this.selected = selectedItem.id; // Assign the selected item based on GUID
        this.onChanged(this.selected);   // Notify Angular Forms of the change
      }
    }
    else{
      if(this.clearSelectedValue)
        this.selected = null; // Clear the selected value
    //this.onChanged(null); // Notify Angular Forms

    }
  }

  writeValue(obj: any): void {
    try {
      this.selected = obj || null;
      if (this.selected) {
        const selectedItem = this._pageResult?.data?.find(item => item.id === this.selected);
        if (selectedItem) {
          this.selected = selectedItem.id; // Sets the selected item by its GUID
        }
      }
      this.onChanged(this.selected);
    } catch (error) {
      console.error('Error setting selected value:', error);
    }
  }


  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  scrollToEnd() {
    if (this._pageResult) {
      if (this._pageResult?.pageInfo?.hasNextPage) {
        this.loading = true;
        this.scrollEnd.emit(this.dataBuffer?.length);
      }
    }
  }

  scroll({ end }) {
    if (
      this.loading ||
      this._pageResult?.data?.length <= this.dataBuffer.length
    ) {
      return;
    }

    if (
      end + this.numberOfItemsFromEndBeforeFetchingMore >=
      this.dataBuffer.length
    ) {
      this.loadToBuffer();
    }
  }

  private loadToBuffer() {
    this.loading = true;
    const len = this.dataBuffer.length;
    const more = this._pageResult.data?.length
      ? this._pageResult?.data?.slice(len, this.getAllDatainField? this._pageResult.data?.length :this.bufferSize + len)
      : [];
    this.dataBuffer = this.dataBuffer.concat(more);
    this.loading = false;
  }

  onChange() {
    this.modelChanged.next('');
  }

  onSearch(term?: string) {
    this._pageResult = new PageResult<any>();
    this.loading = true;
    this.search.emit(term);
  }

  onClear() {
    this._pageResult = new PageResult<any>();
    this.loading = true;
    if (this._allowAll) {
      this.selected = '';
    }
    this.clear.emit(true);
  }

  registerOnChange(fn: any) {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  select(ev) {
    this.onTouched();
    this.onChanged(ev);
    this.selectionChanged.emit(ev);
  }

  blur() {
    this.onTouched();
    if (!this.selected) {
      this.onChanged(null);
      this.search.emit('');
      this.searchTerm = '';
    }
    if(this.multiple==true){
      this.search.emit('');
      this.searchTerm = '';
    }
    if(this.initialSelectedValue){
      this.search.emit('');
      this.searchTerm = '';
    }
  }

  onAdd() {
    this.vs.close();
    this.add.emit(true);
  }

  public resetSelection(): void {
    this.selected = null;
    this.onChanged(null); // notify Angular Forms
    if (this.vs) {
      this.vs.clearModel(); // NgSelect internal clear
    }
  }
  get isValueSelected(): boolean {
    if (this.multiple) {
      return Array.isArray(this.selected) && this.selected.length > 0;
    }
    return !!this.selected;
  }

}
